import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useLogin, useAuth } from './useAuth';

export default function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const { data: user } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Already authenticated — bounce to home.
  React.useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    try {
      await login.mutateAsync({ username, password });
      toast.success('Signed in');
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Login failed';
      toast.error(msg);
    }
  };

  return (
    <div className="malpedia-login-page">
      <form className="malpedia-login-card" onSubmit={handleSubmit}>
        <h1 className="malpedia-login-title">malpediaRAG</h1>
        <p className="malpedia-login-sub">Sign in to continue</p>
        <label className="malpedia-login-field">
          <span>Username</span>
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label className="malpedia-login-field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <button
          type="submit"
          className="malpedia-send-btn"
          disabled={login.isPending || !username || !password}
        >
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
